var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"title":_vm._f("moment")(_vm.moveDate,'MM/DD/YYYY')}},[_vm._v("\n  "+_vm._s(_vm._f("moment")(_vm.moveDate,'from', 'now'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }